import React from "react";
import CommonButtons from "src/shared/components/CommonButtons";

interface PaymentFormProps {
  onCancel: () => void;
  onConfirm: () => void;
  isConfirmDisabled: boolean;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  onCancel,
  onConfirm,
  isConfirmDisabled,
}) => {
  return (
    <div className="flex justify-end gap-4 pt-6 border-t border-gray-200">
      <CommonButtons
        className="min-w-32"
        label="Cancel"
        onClick={onCancel}
        variant="outlineDanger"
      />
      <CommonButtons
        className="min-w-32"
        label="Confirm"
        onClick={onConfirm}
        disabled={isConfirmDisabled}
      />
    </div>
  );
};

export default PaymentForm;
